export enum DragItemType {
  trainPanelSplitter = 'trainPanelSplitter',
  // The ItemType used when the user double-clicks to maximize or restore the trainRouteOrGroup.trainDistanceInterval
 trainDistanceIntervalBarMaximizer = 'trainDistanceIntervalBarMaximizer',
 trainDistanceIntervalBarLeftMaximizer = 'trainDistanceIntervalBarLeftMaximizer',
 trainDistanceIntervalBarRightMaximizer = 'trainDistanceIntervalBarRightMaximizer',
 trainDistanceIntervalBarMover = 'trainDistanceIntervalBarMover',
 trainDistanceIntervalBarLeftExpander = 'trainDistanceIntervalBarLeftExpander',
 trainDistanceIntervalBarRightExpander = 'trainDistanceIntervalBarRightExpander'
};